export const documentTypes = {
    "project": [
        {
            name: "ALL",
            value: 0
        },
        {
            name: "DAILY_REPORT",
            value: 1
        },
        {
            name: "HOURLY_REPORT",
            value: 2
        },
        {
            name: "CORRESPONDENCE",
            value: 3
        },
        {
            name: "CONSTRUCTION_PLAN",
            value: 4
        },
        {
            name: "SUBMISSION_AMENDMENTS_RECEIPT",
            value: 5
        },
        {
            name: "PHOTO_DOCUMENTATION",
            value: 6
        },
        {
            name: "PROJECT_REPORT",
            value: 7
        },
        {
            name: "ESTIMATION",
            value: 8
        },
        {
            name: "MEASUREMENT",
            value: 9,
        },
    ],
    "client": [
        {
            name: "ALL",
            value: 0
        },
        {
            name: "OTHER",
            value: 1
        }
    ]
};
